import React, { useEffect, useState } from "react";
import {
  checkIfBoxHistoryDocumentExists,
  updateBoxHistory,
  updatePlayerAttribute,
} from "../firebase/fireFuncs";
import { saveMoodInHistory } from "../history/historyFuncs";
import { getTimeDiff } from "../misc/helperfuncs";
import activeStore from "../stores/activeStore";
import MainStore from "../stores/MainStore";
import useHandlePlayerArrays from "./useHandlePlayerArrays";
import collectionStore from "../stores/collectionStore";

const makeMood = (type) => {
  return {
    activities: [],
    goals: [],
    focuses: [],
    started: Date.now(),
    ended: null,
    type,
  };
};

const useHandleActiveGoal = () => {
  const [timePassed, setTimePassed] = useState({ seconds: 0, minutes: 0 });
  const { findObjectById, updateObject } = useHandlePlayerArrays();
  const { player, tick } = MainStore();
  const { setActive, goal } = activeStore();
  const [completedGoal, setCompleteGoal] = useState(false);
  const { updateArray, open } = collectionStore();

  function combineMoods(openObject, completed) {
    // combine the moods of the open object with the active moods like in combineActiveRatings
    console.log(
      "complete goal 4 | openObject - ",
      openObject,
      " | completed - ",
      completed
    );
    const moods = { open: openObject.moods, active: goal.moods };
    const newMoods = {
      angry: 0,
      sad: 0,
      happy: 0,
      productive: 0,
      confused: 0,
      exhausted: 0,
    };
    const states = [
      "happy",
      "productive",
      "exhausted",
      "angry",
      "confused",
      "sad",
    ];
    for (let i = 0; i < states.length; i++) {
      const state = states[i];
      newMoods[state] = moods.open[state] + moods.active[state];
    }
    const newOpen = { ...openObject, moods: newMoods };
    newOpen.completed = completed;

    // update the time in the open object
    newOpen.minutes.active += timePassed.minutes;

    if (completed) {
      console.log(
        "completed goal 5 | if(completed) clause fired|openObject - ",
        openObject,
        " | newOpen - ",
        newOpen
      );
      checkIfBoxHistoryDocumentExists(
        player.uid,
        goal.type,
        goal.id,
        onGoalCompletedCheck,
        openObject
      );
    }
    setTimePassed({ seconds: 0, minutes: 0 });
    updateObject("open", newOpen);
    resetActiveObject();
  }

  function resetActiveObject() {
    setActive(null);
    updatePlayerAttribute(player.uid, "active", {
      ...player.active,
      goal: null,
    });
  }

  function combineActiveRatings(objects, completed) {
    // complete goal 3
    console.log(
      "completeGoal 3, | objects - ",
      objects,
      " | completed - ",
      completed
    );
    const numbers = [1, 2, 3, 4, 5];
    const ratings = {
      open: {
        first: objects.open.rating.active.first,
        second: objects.open.rating.active.second,
      },
      active: { first: goal.ratings.first, second: goal.ratings.second },
    };

    const newRatings = {
      active: {
        first: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
        second: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
      },
    };
    // combine the numbers values of the open objects in ratings with the active number values in ratings in a new object
    for (let i = 0; i < numbers.length; i++) {
      const number = numbers[i];
      newRatings.active.first[number] =
        ratings.open.first[number] + ratings.active.first[number];
      newRatings.active.second[number] =
        ratings.open.second[number] + ratings.active.second[number];
    }

    // update the open object with the new ratings
    const newOpen = {
      ...objects.open,
      rating: { ...objects.open.rating, active: newRatings.active },
    };
    combineMoods(newOpen, completed);
  }

  function onGoalCompletedCheck(historyObject, openObject) {
    console.log(
      "complete goal 7 | historyObject - ",
      historyObject,
      " | openObject - ",
      openObject
    );
    const completedBox = { ...openObject, completed: true };
    updateBoxHistory(player.uid, goal.id, goal.type, [
      ...historyObject.array,
      completedBox,
    ]);
    // remove the openBox from the open array
    const newOpenArray = open.goals.filter((b) => b.id != openObject.id);
    console.log("newOpenArray ", newOpenArray, " | open - ", open);
    updateArray("open", "goal", newOpenArray);
  }

  function stopActive(completed) {
    // complete goal 2 stopActive function
    findObjectById(goal.id, "goal", combineActiveRatings, completed);
  }

  // auto saved active every 2 minutes
  function synchronizeActive(type) {
    if (type == "goal") {
      updatePlayerAttribute(player.uid, "active.goal", goal);
    }
  }

  useEffect(() => {
    if (player?.active.goal) {
      const timeDiff = getTimeDiff(player.active.goal.date, Date.now());
      setTimePassed(timeDiff);
    }
    if (tick % 180 == 0 && goal && tick > 0) {
      synchronizeActive("goal");
    }
  }, [tick]);

  function placeNewActive(active) {
    if (active.type == "goal") {
      setActive(active, "goal");
      updatePlayerAttribute(player.uid, "active.goal", active);
    } else {
      console.log("placeNewActive -");
      setActive(active, "box");
      updatePlayerAttribute(player.uid, "active.box", active);
    }
  }

  function onRatingTick(ratingObj, field) {
    const newActive = {
      ...goal,
      ratings: { ...goal.ratings, [field]: ratingObj },
    };
    setActive(newActive, "goal");
  }

  function updateActiveGoalMoods(mood) {
    const newActive = {
      ...goal,
      moods: { ...goal?.moods, [mood]: goal.moods[mood] + 5 },
    };
    setActive(newActive, "goal");
  }

  // increase Mood for active goal
  useEffect(() => {
    if (player && goal) {
      if (tick % 5 == 0) updateActiveGoalMoods(player.active.mood?.type);
    }
  }, [tick]);

  function setActiveMood(mood) {
    const lastMood = player.active.mood;
    if (lastMood) {
      saveMoodInHistory({ ...lastMood, ended: Date.now() }, player.uid);
    }
    updatePlayerAttribute(player.uid, "active.mood", makeMood(mood));
  }

  function onGoalCompleted() {
    // complete goal 1 onGoalCompleted
    stopActive(true);
  }

  return {
    resetActiveObject,
    placeNewActive,
    timePassed,
    onRatingTick,
    updateActiveGoalMoods,
    stopActive,
    setActiveMood,
    onGoalCompleted,
  };
};

export default useHandleActiveGoal;
